const WORKSPACES_DIRECTORY_PATH = '/var/workspaces';
const WORKSPACES_SELECTED_FILENAME = '.selected';
const WORKSPACES_NODE_NAME = 'workspace.json';

export {
  WORKSPACES_DIRECTORY_PATH,
  WORKSPACES_SELECTED_FILENAME,
  WORKSPACES_NODE_NAME
};
